class GiftWrappingComponent extends HTMLElement {
  constructor() {
    super();

    this.giftWrapId = this.dataset.giftWrapId;
    this.loadingIcon = this.querySelector(".m-gift-wrapping--loading");
    this.cartDrawer = document.querySelector("m-cart-drawer");

    const checkbox = this.querySelector("#m-gift-wrapping");

    if (checkbox) {
      checkbox.addEventListener("change", (event) => {
        event.target.checked
          ? this.addGiftWrapping()
          : this.removeGiftWrapping();
      });
    }
  }

  addGiftWrapping(quantity = 1) {
    this.loadingIcon.classList.add("show");

    fetch(`${MinimogSettings.routes.cart_update_url}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        updates: {
          [this.giftWrapId]: quantity,
        },
        attributes: { "gift-wrapping": true },
      }),
    })
      .then((r) => r.json())
      .then((cart) => this.handleCartUpdate(cart))
      .catch(console.error);
  }

  removeGiftWrapping() {
    this.loadingIcon.classList.add("show");

    fetch(`${MinimogSettings.routes.cart_update_url}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        updates: {
          [this.giftWrapId]: 0,
        },
        attributes: {
          "gift-wrapping": false,
          "gift-note": "",
        },
      }),
    })
      .then((r) => r.json())
      .then((cart) => this.handleCartUpdate(cart))
      .catch(console.error);
  }

  handleCartUpdate(cart) {
    this.loadingIcon.classList.remove("show");

    if (document.body.classList.contains("template-cart")) {
      window.location.href = MinimogSettings.routes.cart;
      return;
    }

    if (this.cartDrawer) {
      this.cartDrawer.onCartDrawerUpdate();
      MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, cart);
    }

    document.dispatchEvent(
      new CustomEvent("cart:updated", {
        detail: { cart },
      })
    );
  }
}

customElements.define(
  "m-gift-wrapping-component",
  GiftWrappingComponent
);

class GiftNoteComponent extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "change",
      debounce((event) => {
        fetch(`${MinimogSettings.routes.cart_update_url}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            attributes: {
              "gift-note": event.target.value,
            },
          }),
        });
      }, 300)
    );
  }
}

customElements.define("m-gift-note-component", GiftNoteComponent);
